let $sliders = $('.corporate-examples-js');

initSliders();

function initSliders() {
  $sliders.each((key, slider) => {
    initSlider($(slider));
  });
}

function initSlider($slider) {
  $slider.owlCarousel({
    margin: 15,
    nav: true,
    navText: ['&larr;', '&rarr;'],
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      1100: {
        items: 2,
      },
    },
  });
}